import type { ErrorStateType } from './types';

export const getError = (state): ErrorStateType => state.error;

export const getErrorAction = (state) => getError(state).action;
export const getErrorMessage = (state) => getError(state).message;
export const getErrorType = (state) => getError(state).type;
export const getErrorIsOpened = (state) => getError(state).isOpened;
